
import { RequireAuth } from "../../fabrix/components/authentication/auth-validation";
import { ModuleInfo } from "../../fabrix/types";
import { icons } from "./icons";
import translationJson from "./translations.json";

const moduleRoutes = (): ModuleInfo => {
  return {
    path: "/employee-centre",
    label: "EMPLOYEE_CENTRE",
    name: "employee-centre",
    color: "#0F766E",
    id: "8c1f7a66-8be4-40e9-8f15-29349a1118da",
    lazy: async () => {
      const Page = (await import("./")).default;
      return {
        element: (
          <RequireAuth roles={[]}>
            <Page />
          </RequireAuth>
        ),
      };
    },
    translations: translationJson,
    icons: icons,
    children: [
      {
        path: "/employee-centre/",
        label: "EC_HOME",
        name: "home",
        hide: true,
        id: "ef6e8fef-a5be-43e8-b51c-20d3da7b6eed",
        lazy: async () => {
          const Page = (await import("./routes/home")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/employee-centre/approvals",
        label: "EC_APPROVALS",
        name: "approvals",
        icon: "ec-approvals",
        id: "7c1cb970-80c2-4f73-b78f-f82cb2574d31",
        lazy: async () => {
          const Page = (await import("./routes/approvals")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/employee-centre/payslips",
        label: "EC_PAYSLIPS",
        name: "payslips",
        icon: "ec-payslips",
        id: "5ccf19e9-f543-44d5-b2e6-df8ea63395f7",
        lazy: async () => {
          const Page = (await import("./routes/payslips")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/employee-centre/leave-requests",
        label: "EC_LEAVE_REQUESTS",
        name: "leave-requests",
        icon: "ec-leave-requests",
        id: "c1547137-1baf-43a5-8eeb-ef2fb58e5f11",
        lazy: async () => {
          const Page = (await import("./routes/leave-requests")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/employee-centre/proof-of-employment",
        label: "EC_PROOF_OF_EMPLOYMENT",
        name: "proof-of-employment",
        icon: "ec-proof-of-employment",
        id: "071f15cf-afdc-49f6-ba7c-bbe88f40e329",
        lazy: async () => {
          const Page = (await import("./routes/proof-of-employment")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
    ],
  };
};

export default moduleRoutes;
